import { RecursoCampanhaBase } from '../../recurso-campanha-base';
import { RecursoCampanhaTipo } from '../../tipo';

export class RecursoCampanhaFormTipo {
    id: number;
    nome: string;
    nomePlural: string;
    cardCssClass: string;
    isCollapseOpened = true;
    private _recursos: RecursoCampanhaBase[];
    private _valorTotal = 0;

    constructor(tipo: RecursoCampanhaTipo, recursos: RecursoCampanhaBase[], cardCssClass: string) {
        this.id = tipo.id;
        this.nome = tipo.nome;
        this.nomePlural = tipo.nomePlural;
        this.cardCssClass = cardCssClass;

        this._recursos = [];
        recursos?.forEach(recurso => {
            if (recurso.recursoCampanha?.tipo === this.id) {
                this.add(recurso)
            }
        });
    }

    get recursos(): RecursoCampanhaBase[] {
        return this._recursos;
    }

    get valorTotal(): number {
        return this._valorTotal;
    }

    calcularValorTotal() {
        this._valorTotal = 0;
        this._recursos?.forEach(recurso => this._valorTotal += recurso.valor ?? 0);
    }

    private add(recurso: RecursoCampanhaBase) {
        this._recursos.push(recurso);
        this.calcularValorTotal();
    }

    insert() {
        const sequencia = this.recursos.length + 1;
        const recurso = new RecursoCampanhaBase(sequencia);
        this.add(recurso);
    }

    delete(index: number) {
        if (index >= 0) {
            this._recursos.splice(index, 1);
            this.calcularValorTotal();
        }
    }
}
